export const MODAL_CONTENT = {
  HEADER: 'Our money-back guarantee',
  DESCRIPTION: `StellarFi guarantees that new members will see a credit score increase within 3 months of using StellarFi, or they are entitled to a refund. 
  To qualify, members must use the Lite, Prime or Premium plan as intended, maintain good standing, and have at least one monthly bill paid through StellarFi. 
  The member’s VantageScore 3.0 determines eligibility. 
  Refunds cover only membership fees and must be claimed through StellarFi's Member Success Team within 15 days post-3-month period.
  This guarantee is subject to limitations and may be modified or terminated by StellarFi.`
}
